/**
 * parentGestures — ce qui se redit d'un geste de l'espace parent, d'une surface à l'autre.
 *
 * Trois gestes se montrent à deux endroits : une tuile de l'accueil (`<ParentQuickActionsSection>`)
 * et une ligne de la feuille d'actions d'une séance (`<LiveSessionActionsSheet>`). Leur glyphe est le
 * même partout — c'est à lui qu'on reconnaît le geste d'une surface à l'autre —, et leur libellé
 * aussi quand les deux surfaces le disent de la même façon (« Signaler un retard »). Là où elles le
 * disent autrement, chacune garde sa forme : la tuile ne sait pas encore de quelle séance ni de quel
 * tuteur il s'agit (« Décaler une séance », « Écrire à un tuteur »), la feuille les tient (« Décaler
 * cette séance », « Écrire à Camille »).
 *
 * Les glyphes sont ceux des tuiles, décidés le 17/09 (`DECISIONS.md`, « Trois noms ajoutés au
 * registre d'icônes ») ; la feuille, qui dessinait encore `calendar-alt` et `envelope`, les a
 * rejoints le 29/09.
 *
 * Ici aussi, ce qu'un geste attend pour avoir un sens (`needsSession`, Wajih, 30/09) : sans aucune
 * séance à venir, décaler et signaler un retard n'ont pas de séance à proposer, et écrire à un
 * tuteur n'a pas d'objet. Leurs tuiles restent à leur place, inactives, d'après ce seul fait
 * (`hasUpcomingSession`, du view-model de l'accueil). « Réserver un cours en plus » n'en dépend pas.
 */
import { type IconName } from "../../../../design-system/atoms/icons/Icon/iconRegistry"

export const PARENT_GESTURES = {
    move_session: { icon: "calendar-clock", needsSession: true },
    report_late: { icon: "clock", label: "Signaler un retard", needsSession: true },
    message_tutor: { icon: "comment", needsSession: true },
} as const satisfies Record<string, { icon: IconName; label?: string; needsSession: boolean }>
